import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
import { size, weight, fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { makeStyles } from "@material-ui/styles";
const backgroundUrlDesktop = require("./assets/bg_desktop.svg");
const backgroundUrlMobile = require("./assets/bg_mobile.svg");

const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  height: "calc(100% - 80px)", // height minus top nav bar
  width: "100%",
  position: "absolute",
  bottom: 0,
  left: 0,

  "@media (max-width: 800px)": {
    padding: 20,
  },
};

const paper: CSSProperties = {
  backgroundImage: `url(${backgroundUrlDesktop})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "1000px",
  backgrounPosition: "center",
  borderRadius: 10,
  boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.1)",
  width: "1000px",
  height: "600px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",

  "@media (max-width: 900px)": {
    maxWidth: "none",
    padding: "0px 10px 20px 10px",
    height: "100%",
    width: "100%",
    backgroundImage: `url(${backgroundUrlMobile})`,
  },
};

const loadingBar: CSSProperties = {
  backgroundColor: "transparent",
  position: "absolute",
  bottom: 0,
  width: "100%",
};

const header: CSSProperties = {
  fontSize: "32px !important",
  paddingBottom: "20px !important",
  "@media (max-width: 800px)": {
    fontSize: "26px !important",
  },
};

const buttonContainer: CSSProperties = {
  display: "flex",
  justifyContent: "center",
  marginBottom: 15,
  padding: "5px 0px",
  "@media (max-width: 800px)": {
    width: "100%",
  },
};

const subhead: CSSProperties = {
  fontSize: 24,
  marginBottom: 40,
  color: colors.blueDusk.standard,
  fontFamily: fontFamilySans,
  fontWeight: 600,
  lineHeight: "1.5em",

  "@media (max-width: 900px)": {
    fontSize: "20px !important",
    padding: "0 25px",
  },
};

export const agreement: CSSProperties = {
  color: greys.slate,
  fontSize: size.sm,
  fontWeight: weight.std,
  marginTop: spacing.sm,
  fontFamily: fontFamilySans,
  width: 250,
};

export const link: CSSProperties = {
  color: greys.dark,
  borderBottomWidth: 0,
};
export const signupBtn: { [key: string]: CSSProperties } = {
  base: {
    height: 45,
    lineHeight: `45px`,
    width: "100%",
    maxWidth: 320,
  } as CSSProperties,
  label: {
    fontWeight: 500,
    fontFamily: fontFamilySans,
    fontSize: size.std,
    paddingLeft: spacing.std,
    paddingRight: spacing.lg,
    color: greys.white,
    textTransform: "none",
  },
};

export const useStyles = makeStyles({
  container,
  paper,
  header,
  buttonContainer,
  loadingBar,
  subhead,
});
